module.exports = __webpack_public_path__ + "img/section2_img1.575a4d22.png";